<script lang="ts">
	import IconButton from '../../../../basic/buttons/IconButton.svelte';
	import { contextMenuState } from '../../../../basic/contextmenu/ContextMenuStore';
	import { confirmState } from '../../../../basic/dialog/ConfirmStore';
	import { getColorForString } from '../../../../helper/Colors';
	import {
		type SettingDocumentTypeStore
	} from '../../../../stores/SettingDocumentTypeStore.svelte';
	import type { SettingDocumentType } from '../../../../types/BasicTypes';
	import type { MultiSelectionItem } from '../../../../types/ListTypes';
	import { _ } from 'svelte-i18n';

	interface Props {
		store: SettingDocumentTypeStore;
		item: SettingDocumentType;
		selected: boolean;
		onClick: (e: MouseEvent) => void;
		onChildDeleted: () => void;
		onEditRequest: (item: MultiSelectionItem) => void;
	}

	let { store, item, selected, onClick, onChildDeleted, onEditRequest }: Props = $props();
	let showMenu: boolean = $state(false);

	async function openContextMenu(e: MouseEvent) {
		e.stopPropagation();

		const menuItems = [
			{
				title: $_('general.lbl_edit'),
				callbackFunction: () => {
					onEditRequest(item);
				}
			},
			{
				title: $_('general.lbl_delete'),
				danger: true,
				callbackFunction: () => {
					$confirmState = {
						bodyText: $_('settings.basic.document_labels.lbl_delete_modal').replace(
							'{}',
							item.defaultName
						),
						successCallback: deleteDocumentType,
						warningText: $_('settings.basic.document_labels.lbl_delete_warning'),
						securityCheckText: item.defaultName,
						acceptButtonText: $_('general.lbl_delete')
					};
				}
			}
		];

		$contextMenuState = {
			x: e.clientX,
			y: e.clientY,
			menuItems: menuItems
		};
	}

	function deleteDocumentType() {
		store.deleteDocumentTypeStore(item.id);
		onChildDeleted();
	}
</script>

<button
	onmouseenter={() => {
		showMenu = true;
	}}
	onmouseleave={() => {
		showMenu = false;
	}}
	class:selected
	onclick={(e: MouseEvent) => onClick(e)}
	oncontextmenu={(e: MouseEvent) => {
		e.preventDefault();
		openContextMenu(e);
	}}
	class="rounded-[5px] bg-white dark:bg-dark-400 p-4 text-left relative border-2 border-transparent"
>
	<div class="flex gap-2 items-center">
		<div
			class="w-4 h-4 rounded flex-shrink-0"
			style="background-color: {getColorForString(
				item.defaultName ? item.defaultName.toString() : ''
			)};"
		></div>
		<p class="font-bold flex-shrink text-ellipsis overflow-hidden">
			{item.defaultName}
		</p>
	</div>

	<div class="absolute bottom-0 right-2">
		{#if showMenu}
			<IconButton iconName="ellipsis-h" onClick={openContextMenu} showCircle={false} size="small" />
		{/if}
	</div>
</button>
